import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import { A } from 'components/common/Link/Link'
import PhoneLink from 'components/common/PhoneLink'
import { formatPhoneNumber } from 'helpers/phone-number'
import {
  NORESULT_UHNO,
  NORESULT_FIRST_SENTENCE,
  NORESULT_BY_FILTER_SUFFIX,
  NORESULT_NOSTORE,
  NORESULT_MAIN_TITLE
} from 'components/OneColumnSearchResultPage/constants'
import Button from 'components/common/Button/Button'

const NoResultComponent = ({
  resetFilters,
  storePhoneNumber,
  hasFilters,
  addVehicle,
  hasStore,
  showStoreLocatorModal
}) =>
  <NoResultBlock>
    <NoResultMainTitle>{ NORESULT_MAIN_TITLE }</NoResultMainTitle>
    <NoResultTitle>{ NORESULT_UHNO }</NoResultTitle>
    <NoResultMessage>{ NORESULT_FIRST_SENTENCE }</NoResultMessage>
    {
      storePhoneNumber ?
        <Fragment>
          <Media.Desktop>
            <NoResultMessage>
              {`Please contact your store at ${formatPhoneNumber(storePhoneNumber)} for assistance, or select a different vehicle${hasFilters ? ', ' : '.'}`}
              { hasFilters && <A prevent handler={ resetFilters }>{NORESULT_BY_FILTER_SUFFIX}</A> }
            </NoResultMessage>
          </Media.Desktop>
          <Media.Mobile>
            <NoResultMessage>
              Please contact your store at <PhoneLink number={ storePhoneNumber } />{' '}
              for assistance, or select a different vehicle{`${hasFilters ? ', ' : '.'}`}{' '}
              { hasFilters && <A prevent handler={ resetFilters }>{NORESULT_BY_FILTER_SUFFIX}</A> }
            </NoResultMessage>
          </Media.Mobile>
        </Fragment> :
        <Fragment>
          <NoResultMessage>
            {`${NORESULT_NOSTORE}or select a different vehicle${hasFilters ? ', ' : '.'}`}
            { hasFilters && <A prevent handler={ resetFilters }>{NORESULT_BY_FILTER_SUFFIX}</A> }
          </NoResultMessage>
        </Fragment>
    }
    <ButtonsWrapper hasStore={ hasStore }>
      {!hasStore && (
        <ChooseAStoreButton onClick={ showStoreLocatorModal }>
          Choose A Store
        </ChooseAStoreButton>
      )}
      <SwitchVehicleButton onClick={ addVehicle }>
        Switch Vehicle
      </SwitchVehicleButton>
    </ButtonsWrapper>
  </NoResultBlock>

NoResultComponent.propTypes = {
  addVehicle: PropTypes.func,
  hasFilters: PropTypes.bool,
  hasStore: PropTypes.shape(),
  resetFilters: PropTypes.func,
  showStoreLocatorModal: PropTypes.func,
  storePhoneNumber: PropTypes.string
}

export default NoResultComponent

const NoResultBlock = styled.div`
  text-align: center;
  margin-top: 20px;
`

const NoResultMainTitle = styled.h1`
  margin-bottom: 40px;
  ${Mixin.font.GothamBold(30, 600)}
  text-transform: uppercase;
  text-align: start;
  letter-spacing: 0.5px;
  transform: scale(1, 1.3);
  ${Media.mobile`
    font-size: 28px;
    padding: 0 16px;
  `}
`

const NoResultTitle = styled.h2`
  ${Mixin.font.GothamBold(26, 600)}
  line-height: 1;
  color: ${Theme.colors.black};
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 0 0 20px;
`

const NoResultMessage = styled.div`
  margin-bottom: 5px;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 370px;
  margin: 15px auto 0;
  ${props => props.hasStore && css`
    justify-content: center;
  `}
  ${Media.mobile`
    ${props => !props.hasStore && css`
      flex-direction: column;
    `}
  `}
`

const SwitchVehicleButton = styled(Button)`
  text-transform: uppercase;
`

const ChooseAStoreButton = styled(Button)`
  text-transform: uppercase;
  ${Media.mobile`
    margin-bottom: 30px;
  `}
`
